import { setStorage } from 'utilz';
import * as types from './actions';

export const initialState = {
  needs: []
};

const needsReduce = (_needs, value) => {
  const idx = _needs.findIndex(el => el === value);
  const needs = [..._needs];
  if (idx >= 0) {
    needs.splice(idx, 1);
  } else {
    needs.splice(0, 1, value);
  }

  setStorage({
    needs: {
      needs
    }
  });
  return needs;
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.NEEDS_CHANGE:
      return { ...state, needs: needsReduce(state.needs, payload.need) };
    case 'RESET_STORE':
      return { ...state, ...initialState };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/pages/NeedCar/reducer.js